module.exports = __webpack_public_path__ + "img/img2.866c17dd.png";